import React from 'react'

// can't apply styles directly to label USWDS
const styles = {
    marginTop: '20px',
    marginBottom: '10px'
}

const Label = (props) => {
    const { children, ...rest } = props
    return(
        <div style={(rest.hidden || rest.labelHidden) ? null: styles}>
            <label className={`usa-label`} {...rest}>{children}</label>
        </div>
    )
}

export default Label
